import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { AsyncPipe } from "@angular/common";
import { AlertLabelComponent } from "@shared/components/molecules/alert-label/alert-label.component";
import { ToastNotification, ToastNotificationService } from "@shared/services/toast-notification.service";
import { toastAnimation } from "@shared/animations/toast.animation";
import { RouterLink } from "@angular/router";

@Component({
  selector: "app-toast-notification",
  styleUrls: ["./toast-notification.component.scss"],
  templateUrl: "./toast-notification.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AlertLabelComponent, AsyncPipe, RouterLink],
  animations: [toastAnimation],
})
export class ToastNotificationComponent {
  private readonly toastNotificationService = inject(ToastNotificationService);

  readonly notifications$ = this.toastNotificationService.notifications;

  onDismiss(notification: ToastNotification): void {
    this.toastNotificationService.dismiss(notification.id);
  }

  onAction(notification: ToastNotification, run: () => void): void {
    run();
    this.toastNotificationService.dismiss(notification.id);
  }
}
